import React from "react";
import "./home.css";
import NavBar from "./components/NavBar.js";
import "./skills.css";

export default function Skills() {
  const languages = [
    ["Python", "3 years"],
    ["Java", "6 years"],
    ["C++", "2 years"],
    ["HTML/CSS", "1 year"],
    ["React.js, Node.js, Javascript, Swift", "1 year"],
    ["Assembly, Bluespec", "1 year"],
    ["R, SQL", "1 year"],
  ];
  const categories = [
    [
      "Hardware Components",
      "ESP32, Microcontroller, IMU6050, Gyroscope, GPS, Microphone",
    ],
    [
      "Others",
      "Git, Apache Flume, HTTP Get/Post requests, concurrency, Java Swing, Arduino, VScode",
    ],
  ];
  return (
    <body>
      <NavBar active="skills" />
      <div className="skillsBody">
        <h2>SOME THINGS I'M EXPERIENCED IN</h2>
        <h3>Languages</h3>
        <table className="languagesTable">
          {languages.map((language) => (
            <tr>
              <td>{language[0]}</td>
              <td>{"|"}</td>
              <td>{language[1]}</td>
            </tr>
          ))}
        </table>
        {categories.map((cat) => (
          <div>
            <h3>{cat[0]}</h3>
            <p>{cat[1]}</p>
          </div>
        ))}
      </div>
    </body>
  );
}
